<template>
	<BasePlaceHolder :line-count="10" :placehold="loading" :class="{ 'container marketing-section': loading }">
		<ModularLandingPage :campaign-name="props.campaignName" :partner-notice="partner" />
	</BasePlaceHolder>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { currency } from '@filters/shared-filters';
import { getMediaPartnerNotices } from '@api/sanity/graphql/media-partner-notices';
import { MediaPartnerNoticeData } from 'types/sanity/marketing-components';
import ModularLandingPage from '@views/marketing-site/modular-landing-page.vue';
import { useRoute } from 'vue-router';
import { useThirdPartyAuthStore } from '@stores/third-party-auth';

const route = useRoute();
const thirdPartyAuthStore = useThirdPartyAuthStore();

interface Props {
	campaignName?: string;
}

const props = withDefaults(defineProps<Props>(), {
	campaignName: 'partner'
});

const partnerNotices = ref<Array<MediaPartnerNoticeData>>([]);
const loading = ref(true);

const source = computed((): string => {
	return route.query.utm_source ? (route.query.utm_source as string) : '';
});

const partner = computed((): MediaPartnerNoticeData => {
	const defaultNotice: MediaPartnerNoticeData = {
		payment: currency(225, 0),
		isCpaPartner: true
	};
	const currentPartner = partnerNotices.value.find((p: MediaPartnerNoticeData) => p.utmSource === source.value);
	return currentPartner || defaultNotice;
});

onBeforeMount(() => {
	thirdPartyAuthStore.disable(onBeforeUnmount);
});

async function setup(): Promise<void> {
	const partnerNoticesResponse = await getMediaPartnerNotices('partner-view');
	partnerNotices.value = partnerNoticesResponse?.partnerNotices ?? [];
	loading.value = false;
}

setup();
</script>
